import { ModeOfTransport } from "@iventis/domain-model/model/modeOfTransport";
import { FixedShape } from "@iventis/domain-model/model/fixedShape";
import { MetricName } from "@iventis/domain-model/model/metricName";
import { incrementMonitoringCount } from "../set-monitoring-metric";
import { MetricEvent } from "../metric-types";

const fixedShapeMetricMap: Record<FixedShape, MetricName> = {
    [FixedShape.Rectangle]: MetricName.FIXED_SHAPE_RECTANGLE_USED,
    [FixedShape.Circle]: MetricName.FIXED_SHAPE_CIRCLE_USED,
    [FixedShape.Triangle]: MetricName.FIXED_SHAPE_TRIANGLE_USED,
};

export function drawMapObjectMetric(mapObjectProperties: { fixedShape?: FixedShape; modeOfTransport?: ModeOfTransport }, event: Partial<MetricEvent> = {}) {
    if (mapObjectProperties.fixedShape != null) {
        const metricName = fixedShapeMetricMap[mapObjectProperties.fixedShape] ?? MetricName.FIXED_SHAPE_MAP_OBJECT_USED;
        incrementMonitoringCount({ ...event, name: metricName });
    } else if (mapObjectProperties.modeOfTransport != null) {
        incrementMonitoringCount({ ...event, name: MetricName.ROUTE_MAP_OBJECT_USED });
    } else {
        incrementMonitoringCount({ ...event, name: MetricName.DRAW_MAP_OBJECT_USED });
    }
}
